import { useEffect, useRef, useState } from "react";
import { Transition } from "semantic-ui-react";

const TransitionBetween = (props) => {
  const { children, enter, exit, reverse, duration } = props;
  const [renderdChild, setChild] = useState(children);
  const [visible, setVisibility] = useState(true);
  const init = useRef(true);

  useEffect(() => {
    if (init.current) init.current = false;
    else setVisibility(false);
  }, [children.key]);

  const onHide = () => {
    setChild(children);
    setVisibility(true);
  };

  return (
    <Transition
      visible={visible}
      animation={visible ? (!reverse ? enter : exit) : !reverse ? exit : enter}
      duration={duration}
      onHide={onHide}
    >
      {renderdChild}
    </Transition>
  );
};

export default TransitionBetween;
